import { useState, useEffect } from 'react';
import { Table, Modal, TextInput } from "flowbite-react";
import CustomThemeModal from '../CustomThemes/CustomThemeModal';
import { useGetSuppliers, supplierType } from '../../hooks/Supplier/useGetSuppliers';
import { FaPlus } from "react-icons/fa";

type SupplierModalPropType = {
    openModal: boolean,
    setOpenModal: (value: boolean) => void,
    addSupplier: (supplierName: string) => void
}


const SupplierModal = ({openModal, setOpenModal, addSupplier}: SupplierModalPropType) => {
    const { suppliers, setSuppliers } = useGetSuppliers();
    const [currentSuppliersForSearch, setCurrentSuppliersForSearch] = useState<supplierType[]>([]);
    const [searchSuppliers, setSearchSuppliers] = useState<string>("");
    const [debouncedTerm, setDebouncedTerm] = useState<string>("");


    useEffect(() => {
        const handler = setTimeout(() => {
          setDebouncedTerm(searchSuppliers);
        }, 500); // Delay of 500ms
    
        // Cleanup the timeout if searchSuppliers changes
        return () => clearTimeout(handler);
      }, [searchSuppliers]);
    
      // Fetch results based on debouncedTerm
      useEffect(() => {
        if (debouncedTerm) {
          const filteredSuppliers = suppliers.filter((supplier) =>
          supplier.name.toLowerCase().includes(debouncedTerm.toLowerCase())
          );
          setCurrentSuppliersForSearch(filteredSuppliers);
        } else {
          setCurrentSuppliersForSearch([]);
        }
    }, [debouncedTerm]);    
    return (
        <Modal show={openModal} onClose={() => setOpenModal(false)} size={'lg'} theme={CustomThemeModal}>
                <Modal.Body>
                    <button
                        aria-label="Close"
                        className="absolute top-2 right-2  z-20 ml-auto inline-flex items-center rounded-lg bg-white border-gray-500 border-solid border-2 p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 dark:hover:bg-gray-600 dark:hover:text-white"
                        type="button"
                        onClick={() => setOpenModal(false)}
                    >
                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true" className="h-5 w-5" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Search for Supplier</h3>
                    </div>
                    <div className="mt-2">
                        <TextInput
                            id="searchSuppliers"
                            type="text"
                            value={searchSuppliers}
                            onChange={(e) => setSearchSuppliers(e.target.value)}
                            placeholder='Start typing to search'
                        />
                    </div>
                    <div className="mt-5 h-56 max-h-52 overflow-y-scroll">
                        <Table hoverable>
                            <Table.Body className="divide-y">
                                {currentSuppliersForSearch.map((supplier: any) => {
                                    return (
                                        <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                            <Table.Cell>
                                                {supplier.code} - {supplier.name} ({supplier.currency})
                                            </Table.Cell>
                                            <Table.Cell>
                                                <div className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cyan-100 text-cyan-500 dark:bg-cyan-800 dark:text-cyan-200">
                                                    <FaPlus className="h-3 w-3 text-sm cursor-pointer" onClick={() => addSupplier(supplier.code + " - " +supplier.name + " (" + supplier.currency + ")")} />
                                                </div>
                                            </Table.Cell>
                                        </Table.Row>
                                    )
                                })}

                            </Table.Body>
                        </Table>
                    </div>
                </Modal.Body>
            </Modal>
    )
}


export default SupplierModal;